var map = {
	"./aboutus/address.svg": "ZT8A",
	"./aboutus/banner-1.jpg": "oS+z",
	"./aboutus/logo-1.jpg": "dXKo",
	"./aboutus/logo-2.png": "Sooj",
	"./aboutus/logo-3.jpg": "JOoA",
	"./aboutus/logo.svg": "Xp30",
	"./aboutus/pic-2.png": "vgwV",
	"./banner-2-bgc.png": "P3Uk",
	"./banner-2-hover.png": "NQmV",
	"./banner-4-1.jpg": "2i1q",
	"./banner-4-2.jpg": "7GHd",
	"./banner-4-3.jpg": "UrDy",
	"./banner-text.svg": "T7dw",
	"./bg-4-1.jpg": "O8Cy",
	"./bg-4-2.jpg": "KnVV",
	"./bg-4-3.jpg": "Zot6",
	"./collapse-1-icon.png": "f3wq",
	"./collapse-2-icon.png": "zJZb",
	"./collapse-3-icon.png": "CEJT",
	"./consultation-icon.svg": "acnP",
	"./customerCarousel/1.png": "wykY",
	"./customerCarousel/10.png": "20cJ",
	"./customerCarousel/11.png": "v/H/",
	"./customerCarousel/12.png": "pGkt",
	"./customerCarousel/13.png": "eWBq",
	"./customerCarousel/14.png": "IYHM",
	"./customerCarousel/15.png": "Fwvx",
	"./customerCarousel/16.png": "MT2T",
	"./customerCarousel/17.png": "miyB",
	"./customerCarousel/18.png": "485G",
	"./customerCarousel/19.png": "vAlj",
	"./customerCarousel/2.png": "WkvJ",
	"./customerCarousel/20.png": "kuxV",
	"./customerCarousel/21.png": "3b1O",
	"./customerCarousel/22.png": "in20",
	"./customerCarousel/23.png": "nz0G",
	"./customerCarousel/24.png": "RyGO",
	"./customerCarousel/25.png": "qVZz",
	"./customerCarousel/26.png": "oUle",
	"./customerCarousel/27.png": "hyRP",
	"./customerCarousel/28.png": "XIm3",
	"./customerCarousel/29.png": "aUdh",
	"./customerCarousel/3.png": "GTU6",
	"./customerCarousel/30.png": "xGWY",
	"./customerCarousel/4.png": "b0t0",
	"./customerCarousel/5.png": "Zan2",
	"./customerCarousel/6.png": "5Zv1",
	"./customerCarousel/7.png": "YIG1",
	"./customerCarousel/8.png": "cwzn",
	"./customerCarousel/9.png": "YaRb",
	"./footer-logo.png": "ScAa",
	"./footer_wx.png": "Y0b7",
	"./form-bg.png": "JEw2",
	"./icp.png": "0f0e",
	"./img-4-1.png": "Bvhm",
	"./img-4-2.png": "kfC9",
	"./img-4-3.png": "rqXB",
	"./logo.png": "7Otq",
	"./logo.svg": "AqYs",
	"./module-icon-1.png": "TVKm",
	"./module-icon-2.png": "f0bE",
	"./module-icon-3.png": "8OKQ",
	"./part-core-01.svg": "8rM/",
	"./part-core-02.svg": "7H9Z",
	"./part-core-bg.png": "ywJj",
	"./part-etflow-bg1.svg": "QrSO",
	"./part-etflow-bg2.svg": "QDhv",
	"./part-exampel-bg-01.jpg": "cAbs",
	"./part-exampel-bg-02.jpg": "RDUP",
	"./part-exampel-bg-03.jpg": "85GD",
	"./part-exampel-bg-04.jpg": "uDjA",
	"./part-exampel-bg-05.jpg": "yUBj",
	"./part-exampel-bg-06.jpg": "VhEe",
	"./part-module-bg.jpg": "mBgv",
	"./part-value-bg.svg": "Jpeb",
	"./part-value-hover.svg": "n8D7",
	"./pdf1/IMG_00001.png": "h/wO",
	"./pdf1/IMG_00002.png": "nygJ",
	"./pdf1/IMG_00003.png": "blha",
	"./pdf1/IMG_00004.png": "1d6P",
	"./pdf1/IMG_00005.png": "WpOC",
	"./pdf1/IMG_00006.png": "QvDf",
	"./pdf1/IMG_00007.png": "zh7R",
	"./pdf2/IMG_00001.png": "FzXX",
	"./pdf2/IMG_00002.png": "8WDH",
	"./pdf2/IMG_00003.png": "E6dL",
	"./pdf2/IMG_00004.png": "5DcI",
	"./pdf2/IMG_00005.png": "N+sn",
	"./pdf2/IMG_00006.png": "o/Pl",
	"./pdf2/IMG_00007.png": "zf8G",
	"./product-01.jpg": "9tqd",
	"./product-02.jpg": "ZXbq",
	"./product-03.jpg": "3+QD",
	"./resolution/banner1.jpg": "nAW6",
	"./resolution/banner2.jpg": "ZjIT",
	"./resolution/banner3.jpg": "I1rQ",
	"./resolution/banner4.jpg": "YeO1",
	"./resolution/banner5.jpg": "WbYJ",
	"./resolution/banner6.jpg": "Aj0j",
	"./resolution/energy-bg01.jpg": "uxm1",
	"./resolution/energy-bg02.jpg": "QYvn",
	"./resolution/energy-img01-01.png": "a5+x",
	"./resolution/energy-img02-01.png": "ukD7",
	"./resolution/port-bg01.jpg": "4JyQ",
	"./resolution/port-img01-01.png": "YpYE",
	"./resolution/power-bg01.jpg": "TLqk",
	"./resolution/power-bg02.jpg": "3ui4",
	"./resolution/power-bg03.jpg": "wdKe",
	"./resolution/power-bg04.jpg": "XNJS",
	"./resolution/power-bg05.jpg": "ky0T",
	"./resolution/power-img01-01.png": "OGQV",
	"./resolution/power-img01-02.png": "g9nX",
	"./resolution/power-img02-01.png": "ZQuO",
	"./resolution/power-img03-01.png": "u1rJ",
	"./resolution/power-img04-01.png": "raR8",
	"./resolution/power-img05-01.png": "+2wo",
	"./resolution/power-img05-02.png": "tJKz",
	"./resolution/teach-bg01.jpg": "aJoN",
	"./resolution/teach-bg02.jpg": "RQeW",
	"./resolution/teach-bg03.jpg": "4UA0",
	"./resolution/teach-img01-01.png": "OOJd",
	"./resolution/teach-img02-01.png": "bR/o",
	"./resolution/teach-img03-01.png": "EGw0",
	"./resolution/traffic-bg01.jpg": "GueM",
	"./resolution/traffic-bg02.jpg": "8p6s",
	"./resolution/traffic-img01-01.png": "3XUO",
	"./resolution/traffic-img02-01.png": "LS13",
	"./resolution/video-bg01.jpg": "PotD",
	"./resolution/video-img01-01.png": "Ub3p",
	"./super-01.jpg": "8dpL",
	"./super-02.jpg": "QSAi",
	"./super-03.jpg": "vnKs",
	"./video.jpg": "MAT+"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "PvXa";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*$
// module id = PvXa
// module chunks = 7